import { render, staticRenderFns } from "./scroll_bar.vue?vue&type=template&id=8b799fb6&scoped=true&"
import script from "./scroll_bar.vue?vue&type=script&lang=js&"
export * from "./scroll_bar.vue?vue&type=script&lang=js&"
import style0 from "./scroll_bar.vue?vue&type=style&index=0&id=8b799fb6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b799fb6",
  null
  
)

export default component.exports